import React, { Component } from 'react'
import { connect } from 'react-redux'

import { storeItem } from 'utils/tokenStore';
import getDomainURL from 'utils/api'
import { setCurrentRole, getProfile } from 'actions/profile' 
import { storeLoginEmail } from 'actions/email'
import { 
  getSessions,
  setSessionID
} from 'actions/session'

import Axios from 'axios'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      showPassword: false,
      showErrorMessage: false,
      errorMessage: '',
      showSuccessMessage: false,
      successMessage: ''
    }

    onChangeHOC = ( val, context ) => this.setState({ [context]: val })

    onClickLogin = ({ email, password }) => {
      this.setState({ showErrorMessage: false, showSuccessMessage: false })
      this.props.storeLoginEmail( email )
      this.setState({ loading: true }, () => {
        Axios.post(
          `${ getDomainURL() }/login`, {
            email,
            password,
            encode_type: 'JWT'
          }).then( response => {
            this.setState({ loading: false })
            storeItem( 'USM_IMS_TOKEN', response.data.token )
            Promise.all([
              this.props.getProfile( true ),
              this.props.getSessions(btoa(`{"page":0, "per_page": 1000, "filter":{ "sessions.hide_session": false }}`))
            ]).then(() => {
              this.props.history.push( '/dashboard/statistics' )
            })
          }).catch( error => {
            this.setState({ 
              showErrorMessage: true, loading: false, 
              errorMessage: error.response.data.message 
            })
        });
      })
    }

    onClickForgotPassword = ( email ) => {
      this.setState({ showErrorMessage: false, showSuccessMessage: false })
      if ( !email ) {
        return this.setState({ 
          showErrorMessage: true, 
          errorMessage: 'Please enter your email first.' 
        })
      }
      this.setState({ loading: true }, () => {
        Axios.post(
          `${ getDomainURL() }/password-reset/request`, {
            email
          }).then( response => {
            this.setState({ 
              loading: false,
              showSuccessMessage: true,
              successMessage: 'Password reset link has been sent to your email.'
            })
          }).catch( error => {
            this.setState({ 
              showErrorMessage: true, loading: false, 
              errorMessage: error.response?.data?.message || 'Failed to send password reset email.'
            })
        });
      })
    }

    render = () => {
      return (
        <WrappedComponent 
          { ... this.props }
          showPassword={ this.state.showPassword }
          showErrorMessage={ this.state.showErrorMessage }
          showSuccessMessage={ this.state.showSuccessMessage }
          onLoadLogin={ this.state.loading }
          errorMessage={ this.state.errorMessage }
          successMessage={ this.state.successMessage }
          onChangeHOC={ this.onChangeHOC }
          onClickLogin={ this.onClickLogin }
          onClickForgotPassword={ this.onClickForgotPassword }/>
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps, {
    getSessions,
    setCurrentRole,
    getProfile,
    setSessionID,
    storeLoginEmail
  })( WithHOC );
}
export default HOC